/**
 * file to export environment variables and configuration variables for app
 */

const domain = window.location.host;
let API_PATH;
let API_PATH_GCOM = '';
let API_PATH_TOOLS = '';
let HOST = window.location.origin;
const APP_LOCAL_PATH = 'developer.gartner.com';
let ENV = '';

const GCOM_ENV = {
  DEV: 'https://gcom.pdodev.aws.gartner.com',
  QA: 'https://gcom.pdoqa.aws.gartner.com',
  PROD: 'https://www.gartner.com',
};

const TOOLS_ENV = {
  DEV: 'https://toolsdv.gartner.com',
  QA: 'https://toolsqa.gartner.com',
  PROD: 'https://tools.gartner.com',
};

const isProd = (domain === 'tools.gartner.com');

if (domain.indexOf('developer.gartner.com') !== -1) {
  API_PATH = 'https://toolsdv.gartner.com';
  HOST = 'https://toolsdv.gartner.com';
  ENV = 'dev';
}

if (
  domain.indexOf('toolsdev') !== -1
  || domain.indexOf('developer.gartner.com') !== -1
  || domain.indexOf('toolsdv') !== -1
) {
  API_PATH_GCOM = GCOM_ENV.DEV;
  API_PATH_TOOLS = TOOLS_ENV.DEV;
  ENV = 'dev';
} else if (domain.indexOf('toolsqa') !== -1) {
  API_PATH_GCOM = GCOM_ENV.QA;
  API_PATH_TOOLS = TOOLS_ENV.QA;
  ENV = 'qa';
} else if (domain.indexOf('tools.') !== -1) {
  API_PATH_GCOM = GCOM_ENV.PROD;
  API_PATH_TOOLS = TOOLS_ENV.PROD;
  ENV = 'prod';
}

const ConfigPath = {
  GARTNER_URL: API_PATH_GCOM,
  TOOLS_URL: API_PATH_TOOLS,
  API_PATH,
  IS_PROD: isProd,
  HOST,
  APP_LOCAL_PATH,
  TOKEN_KEY_INFO: 'genie_uid',
  GENIE_AUTH_PARAMS_DES: 'name=des',
  GENIE_AUTH_PARAMS_CSVB: 'name=csbvb',
  ENV,
};

export default ConfigPath;
